import { render, staticRenderFns } from "./EditLeaf.vue?vue&type=template&id=5d5c03b9"
import script from "./EditLeaf.vue?vue&type=script&lang=js"
export * from "./EditLeaf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports